import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

class AdminRoleEnterpriseComponentMetadata extends EnterpriseComponentMetadata {
    constructor() {
        super();

        this.name = "AdminRole";
        this.defaultCacheSize = 50;

        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata(
            "USID", // name
            false, // NoCopy
            true, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            36,   // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["Name"] = new EnterpriseComponentAttributeMetadata(
            "Name", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            100,   // length
            null, // minLength
            null, // pattern
            "String", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["Status"] = new EnterpriseComponentAttributeMetadata(
            "Status", // name
            false, // NoCopy
            false, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            "ActiveInactive", // Picklist
            null, // Scale
            null, // Precision
            null,   // length
            null, // minLength
            null, // pattern
            "String", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["Realm"] = new EnterpriseComponentAttributeMetadata(
            "Realm", // name
            false, // NoCopy
            true, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            36,   // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["CreatedDatetime"] = new EnterpriseComponentAttributeMetadata(
            "CreatedDatetime", // name
            false, // NoCopy
            true, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            null,   // length
            null, // minLength
            null, // pattern
            "Datetime", // Type
            null,  // default value
            false,  // computed
        );
    }
}

export default AdminRoleEnterpriseComponentMetadata;
